<template>
  <!-- 资讯详情页面 -->
  <div class="bgs">
    <Header></Header>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="main">
      <div class="main_left">
        <div class="titles">{{details.title}}</div>
        <div class="page_info">
          <img class="info_img" :src="token!=null?details.headimg:details.headimg" alt="">
          <span class="info_name">{{token!=null?details.nicknames:details.nickname}}</span>
          <div class="info_data">发布时间：{{details.date}}</div>
          <div class="info_comment">评论数{{details.num_comment}}</div>
          <div class="info_pv">阅读数量{{details.num_pv}}</div>
        </div>
        <div class="Contents" v-html="details.content">
        </div>
        <!-- 点赞 -->
        <div class="dz_box" v-if="details.is_click==0" @click="isdianzan">
          <img src="https://www.qudonghao.cn/static/assets/images/dz.png" alt="">
          <span style="font-size:14px;color:#fff;">{{details.is_click}}</span>
        </div>
        <div class="dz_box" v-if="details.is_click==1" @click="isdianzans">
          <img src="https://www.qudonghao.cn/static/assets/images/dz.png" alt="">
          <span style="font-size:14px;color:#fff;">{{details.is_click}}</span>
        </div>
        <div class="dz_box" v-if="details.is_click==undefined" @click="isdianzans">
          <img src="https://www.qudonghao.cn/static/assets/images/dz.png" alt="">
          <span style="font-size:14px;color:#fff;">0</span>
        </div>
        <!-- 分享 -->
        <div class="fx_friend">
          <div>分享到：</div>
          <div class="kzl_qfriend_share" id="qq" @click="Go_qq">
          </div>
          <div class="kzl_qfriend_share" id="qqkj" @click="Go_kj"></div>
          <div class="kzl_qfriend_share" id="wb" @click="Go_wb"></div>
        </div>
        <!-- 评论 -->
        <div class="comment">
          <textarea class="textarea" v-model="ipt" name="" id="" cols="30" rows="10" placeholder="请输入要评论的内容"></textarea>
          <div class="comment_sub" style="" @click="Submit_comment">立即评论</div>
        </div>
        <!-- 评论列表 -->
        <div class="comment_list_box">
          <div class="comment_list_title">全部评论{{Comment_List.length}}</div>
          <div class="comment_list_box" v-for="(item,index) in Comment_List" :key='index'>
            <div class="comment_list">
              <div class="comment_list_left">
                <img :src="item.headimgurl" alt="">
                <div class="comment_list_left_info">
                  <div style="margin-bottom:10px;font-size:15px;">{{item.nickname}}</div>
                  <div style="margin-bottom:10px;">{{item.content}}</div>
                  <div style="font-size:15px;color:#999;">{{item.add_time}}</div>
                </div>
              </div>
              <div class="comment_list_right">
                <div class="dianzan" @click="DK_OneDZ(item.id)">
                  <img src="https://www.qudonghao.cn/static/assets/images/wz_dz.png" alt="">
                  <span>{{item.praise}}</span>
                </div>
                <div class="pinglun" @click="DK_OneHf(index)">
                  <img src="https://www.qudonghao.cn/static/assets/images/wz_pl.png" alt="">
                  <span>{{item.reply}}</span>
                </div>
              </div>
            </div>
            <div class="Hf_pl" v-if="index==i">
              <input type="text" class="hf_ipt" v-model="HF_ipt" :placeholder="'回复：'+item.nickname">
              <div class="Hf_btn" @click="One_HFPL(item.id)">回复</div>
            </div>
            <!-- 二级回复 -->
            <div class="comment_list_children_box" v-for="(Citem,Cindx) in item.childrenList" :key="Cindx">
              <div class="comment_list_children">
                <div class="comment_list_children_left">
                  <img :src="Citem.headimgurl" alt="">
                  <div class="comment_list_left_info">
                    <div style="margin-bottom:10px;font-size:15px;">{{Citem.nickname}}</div>
                    <div style="margin-bottom:10px;"><span style="font-size:14px;color:#666">回复 <span
                          style="font-size:16px;color:#333">{{Citem.or_nickname}}</span> ：</span>{{Citem.content}}</div>
                    <div style="font-size:15px;color:#999;">{{Citem.add_time}}</div>
                  </div>
                </div>
                <div class="comment_list_children_right">
                  <div class="dianzan" @click="ChildrenDK_OneDZ(Citem.id)">
                    <img src="https://www.qudonghao.cn/static/assets/images/wz_dz.png" alt="">
                    <span>{{Citem.praise}}</span>
                  </div>
                  <div class="pinglun" :id="'h'+Citem.id" @click="ChildrenDK_OneHf(Citem.id)">
                    <img src="https://www.qudonghao.cn/static/assets/images/wz_pl.png" alt="">
                    <span>{{Citem.reply}}</span>
                  </div>
                </div>
              </div>
              <div class="Hf_pl" v-if="'h'+Citem.id==childrenids">
                <input type="text" class="hf_ipt" v-model="Children_HF_ipt" :placeholder="'回复：'+Citem.nickname">
                <div class="Hf_btn" @click="Two_HFPL(Citem.id)">回复</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main_fixed">
        <div class="main_right">
          <div class="Search">
            <img src="../assets/img/search_icon.png" class="dw_img" alt="">
            <input type="text" class="ipt" @keyup.enter="Go_search" v-model="search" placeholder="搜资讯">
            <button class="Go_search" @click="Go_search">搜索</button>
          </div>
          <div class="PersonalProfile" >
            <div class="userimg" @click="Go_AuthorsHome">
              <img class="border_img" v-if="details.user_role==1" src="@/assets/img/zhuanjia_daimg.png" alt="">
              <img class="border_img" v-if="details.user_role==2" src="@/assets/img/jigou_daimg.png" alt="">
              <img class="content_img" :src="details.headimg" alt="">
            </div>
            <div style="text-align:center;margin:20px 0 17px;font-size:18px;font-weight:800;color:#333333;">
              {{token!=null?details.nicknames:details.nickname}}</div>
            <div style="text-align:center;font-size:16px;color:#666666;line-height:30px;">
              {{details.title}}</div>
             <div v-if="token!=null">
                <div v-if="isuid.id!=details.uid">
              <div class="guanzhu1" v-if="isguanzhu==true" @click="guanzhu">关注</div>
              <div class="guanzhu2" v-if="isguanzhu==false" @click="quguan">已关注</div>
            </div>
            </div>
            <div v-if="token==null">
              <div class="guanzhu1" v-if="isguanzhu==true" @click="guanzhu">关注</div>
              <div class="guanzhu2" v-if="isguanzhu==false" @click="quguan">已关注</div>
            </div>
          </div>
          <div class="main_right_list">
            <div class="main_right_list_title">
              <div class="shugang"></div>
              <div>相关资讯</div>
            </div>
            <div class="main_right_list_l" v-for="(item,index) in RelevantInformations" :key="index"
              @click="Go_InformationDetails(item.id)">
              <div class="yuandian">●</div>
              <div class='titles'>{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import {
  Isdetail,
  comment_save,
  praise,
  comment_list,
  save_coment,
  Relation,
  praisesave,
} from "@/api/api";
import Axios from "axios";
export default {
  // 资讯详情
   metaInfo(){
     return{
        title: this.details.title==undefined?'资讯详情':this.details.title+'_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: this.details.title
            },
            {
                name: 'description',
                content: this.details.content
            }
        ]
     }     
    },
  inject: ["reload"],
  name: "InformationDetails",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      isuid:JSON.parse(localStorage.getItem("userInfo")),
      search: "",
      token: localStorage.getItem("token"),
      num: 0,
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isguanzhu: true,
      details: "",
      ipt: '',
      isOneHF: false,
      Comment_List: [], //评论列表
      i: -1,
      childreni: -1, //二级
      HF_ipt: "", //回复评论输入框
      Children_HF_ipt: "", //二级回复评论输入框
      RelevantInformations: [],
      childrenids:'',
    };
  },
  created() {
    // console.log(this.$route.query.id);
    this.Details(this.$route.query.id);
    this.Comment_list(this.$route.query.id);
    this.RelevantInformation(); //相关资讯
  },
  mounted() {},
  // watch: {
  //   $route(n, o) {
  //     if (n.fullPath !== o.fullPath) {
  //       //监听路由参数是否变化
  //       this.reload();
  //     }
  //   },
  // },
  methods: {
    Go_AuthorsHome(){
       this.$router.push({ name: "AuthorsHome", query: { id: this.details.uid} });
    },
    // 跳转相关资讯详情
    Go_InformationDetails(id) {
      this.$router.push({ name: "InformationDetails", query: { id: id } });
      this.reload();
    },
    // 相关资讯
    RelevantInformation() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/content_relevant",
        params: {},
      }).then((res) => {
        ////console.log(res.data.data);
        this.RelevantInformations = res.data.data;
      });
    },
    DK_OneDZ(id) {
      var that = this;
      if (this.token != null) {
        praisesave({
          comid: id,
          type: 0,
        }).then((res) => {
          ////console.log(res);
          if (res.data.code == 200) {
            this.$message.success("点赞成功");
            that.reload();
          } else {
            this.$message.success(res.data.msg);
            that.reload();
          }
        });
      } else {
        this.$message.warning("请您登录以后点赞");
      }
    },
    // 回复评论
    One_HFPL(id) {
      save_coment({
        comid: id,
        content: this.HF_ipt,
      }).then((res) => {
        ////console.log(res);
        if (res.data.code == 200) {
          this.$message.success("回复成功");
          this.reload();
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    // 回复评论二级
    Two_HFPL(id) {
      save_coment({
        comid: id,
        content: this.Children_HF_ipt,
      }).then((res) => {
        ////console.log(res);
        if (res.data.code == 200) {
          this.$message.success("回复成功");
          this.reload();
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    DK_OneHf(index) {
      if (this.token != null) {
        if (this.i == index) {
          this.i = -1;
        } else {
          this.i = index;
        }
      } else {
        this.$message.warning("请您登录以后回复");
      }
    },
    ChildrenDK_OneDZ(id) {
      if (this.token != null) {
        praisesave({
          comid: id,
          type: 0,
        }).then((res) => {
          ////console.log(res);
          if (res.data.code == 200) {
            this.$message.success("点赞成功");
            this.reload();
          } else {
            this.$message.success(res.data.msg);
            this.reload();
          }
        });
      } else {
        this.$message.warning("请您登录以后点赞");
      }
    },
    ChildrenDK_OneHf(id) {
      
      if(this.token!=null){
        this.childrenids='h'+id;
      }else{
      this.$message.warning("请您登录以后回复");
      }
      // if (this.token != null) {
      //   if (this.childreni == index) {
      //     this.childreni = -1;
      //   } else {
      //     this.childreni = index;
      //   }
      // } else {
      //   this.$message.warning("请您登录以后回复");
      // }
    },
    Comment_list(id) {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/commentList",
        params: {
          content_id: id,
        },
      }).then((res) => {
        ////console.log(res.data);
        this.Comment_List = res.data.data.data;
      });
      // comment_list({
      //   cid: id,
      // }).then((res) => {
      //   ////console.log(res);
      //   this.Comment_List=res.data.data
      // });
    },
    isdianzan() {
      if (this.token != null) {
        praise({
          type:1,
          cid: this.details.id,
        }).then((res) => {
          ////console.log(res);
          if (res.data.code == 200) {
            this.details.is_click = 1;
            this.$message.success("点赞成功");
          } 
        });
      } else {
        this.$message.warning("请您登录以后点赞");
      }
    },
    isdianzans() {
      if (this.token != null) {
        praise({
          type:0,
          cid: this.details.id,
        }).then((res) => {
          ////console.log(res);
          if (res.data.code == 200) {
            this.details.is_click = 0;
           this.$message.warning("取消点赞");
          }
        });
      } else {
        this.$message.warning("请您登录以后点赞");
      }
    },
    Submit_comment() {
      ////console.log(this.ipt);
      if (this.token != null) {
        if(this.ipt!=''){
          comment_save({
          cid: this.details.id,
          content: this.ipt,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("评论成功");
            setInterval(() => {
              this.$router.go(0);
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
          ////console.log(res);
        });
        }else{
           this.$message.warning("输入内容不能为空");
        }  
      } else {
        this.$message.warning("请您登录以后评论");
      }
    },
    Go_qq() {
      let urls = "http://research.qudong.com/InformationDetails?id=" + this.details.id;
      window.open(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
          encodeURIComponent(urls) +
          "&title=" +
          this.details.title +
          "&summary=" +
          this.details.title
      );
    },
    Go_kj() {
      let urls = "http://research.qudong.com/InformationDetails?id=" + this.details.id;
      window.open(
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
          encodeURIComponent(urls) +
          "&title=" +
          this.details.title +
          "&summary=" +
          this.details.title
      );
    },
    Go_wb() {
      let urls = "http://research.qudong.com/InformationDetails?id=" + this.details.id;
      window.open(
        "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(urls) +
          "&title=" +
          this.details.title +
          "&summary=" +
          this.details.title
      );
    },
    // 关注
    guanzhu() {
      if (this.token != null) {
        Axios({
          method: "post",
          url: "https://researchadmin.qudong.com/index/detail/relation",
          params: {
            id: this.details.uid,
          },
          headers: {
            token: this.token,
          },
        }).then((res) => {
          ////console.log(res);
          if (res.data.code == 200) {
            this.isguanzhu = false;
            this.$message.success("关注成功");
          }
        });
      } else {
        this.$message.warning("请您登录以后关注");
      }
    },
    quguan() {
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/index/detail/relation",
        params: {
          id: this.details.uid,
        },
        headers: {
          token: this.token,
        },
      }).then((res) => {
        ////console.log(res);
        if (res.data.code == 201) {
          this.isguanzhu = true;
          this.$message.success("取消关注");
        }
      });
    },
    // 详情页面展示
    Details(id) {
      // 这里、、、、、、、、、、、、、、、、、、、、、、、、、
      if (this.token != null) {
        Isdetail({
          cid: id,
        }).then((res) => {
          ////console.log(res.data);
      
          if (res.data.code == 200) {
            this.details = res.data.data;
            // this.datas1 = this.details.create_time.slice(0, 11);
            //  关注状态
              Axios({
                method: "post",
                url: "https://researchadmin.qudong.com/index/detail/relation_status",
                params: {
                  id: this.details.uid,
                },
                headers: {
                  token: this.token,
                },
              }).then((res) => {
                ////console.log(res.data.data);
                if (res.data.data == 0) {
                  this.isguanzhu = true;
                } else {
                  this.isguanzhu = false;
                }
              });
          }else if(res.data.code ==4004){
            this.$router.push({
          name: "404",
        });
          }
        });
      } else {
        Axios({
          method: "get",
          url: "https://researchadmin.qudong.com/api/update_data_one",
          params: {
            id: id,
            type: 3,
          },
        }).then((res) => {
          ////console.log(res);
          this.details = res.data.data;
          this.datas1 = this.details.create_time.slice(0, 11);
        });
      }
    },
    Go_search() {
      if (this.search == "") {
        return this.$message.warning("输入内容不能为空!");
      } else {
        this.$router.push({
          name: "Searchrefer",
          query: { search: this.search },
        });
      }
    },
  },
};
</script>

<style scoped>
.bgs {
  background: #f5f7f9;
}

.crumbs {
  width: 1200px;
  margin: 20px auto;
  padding-left: 50px;
}
.main {
  width: 1200px;
  margin: 0 auto 80px;
  display: flex;
  justify-content: space-between;
}
.main_left {
  width: 780px;
  padding: 20px 40px;
  background: #fff;
}
.main_right {
  width: 320px;
  position: sticky;
  top: 20px;
  right: 0;
}
.main_left_top {
  display: flex;
  padding: 30px;
  justify-content: space-between;
}
.main_left_top_l img {
  width: 298px;
  height: 298px;
}
.main_left_top_r {
  width: 480px;
}
.main_left_top_r .title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin: 20px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.type_num {
  display: flex;
}
.type_num span {
  display: inline-block;
  width: 210px;
  margin-right: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.TransactionPrice {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  display: flex;
  align-items: center;
}
.Purchase_zx {
  margin-top: 8px;
  width: 180px;
  height: 42px;
  background: #3463db;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  line-height: 42px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.main_left_content {
  padding: 30px;
}
.title_img {
  display: flex;
  align-items: center;
}
.title_img p {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.contents {
  word-wrap: break-word;
  margin: 30px 0 0;
}
.main_left_bottom {
  margin-top: 20px;
}
.bgss {
  background: #f5f7f9;
  height: 16px;
}
.main_left_bottom {
}
.main_left_bottom img {
  padding: 30px;
  width: 800px;
  height: 280px;
}
.ipt {
  width: 242px;
  height: 34px;
  border: 1px solid #3463db;
  padding-left: 30px;
}
.Go_search {
  width: 77px;
  height: 36px;
  background: #3463db;
  border: none;
  color: #fff;
}
.Search {
  display: flex;
  position: relative;
}
.dw_img {
  position: absolute;
  top: 9px;
  left: 10px;
  width: 15px;
  height: 17px;
}
.main_right_list {
  width: 320px;
  height: 430px;
  margin-top: 21px;
  background: #fff;
}
.main_right_list .shugang {
  width: 4px;
  height: 28px;
  background: #3463db;
  margin-right: 10px;
}
.main_right_list_title {
  width: 320px;
  height: 49px;
  display: flex;
  align-items: center;
  color: #3463db;
  border: 1px solid #e8e8e8;
}
.main_right_list_l {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
}
.main_right_list_l .yuandian {
  margin-right: 10px;
  color: #999999;
}
.titles {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  -webkit-box-orient: vertical;
}
>>> .el-dialog {
  width: 500px !important;
}
>>> .el-form-item__label {
  width: 100px !important;
}
>>> .el-form-item__content {
  margin-left: 100px !important;
}
>>> .el-dialog__header {
  border-bottom: 2px solid #3463db;
  text-align: center;
}
>>> .dialog-footer {
  display: flex;
  justify-content: center;
}
>>> .el-button--primary {
  width: 160px;
}
.PersonalProfile {
  width: 248px;
  background: #fff;
  padding: 16px 36px;

  margin-top: 21px;
}
.userimg {
  position: relative;
  width: 96px;
  height: 100px;
    cursor: pointer;
  margin: 0 auto;
}
.border_img {
  width: 96px;
  height: 100px;
  position: relative;
  z-index: 111;
}
.content_img {
  position: absolute;
  border-radius: 50%;
  width: 81px;
  top: 17px;
  left: 3px;
  height: 82px;
}
.guanzhu1 {
  width: 120px;
  height: 40px;
  border: 1px solid #3463db;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: #3463db;
  margin: 24px auto 10px;
}
.guanzhu2 {
  width: 120px;
  height: 40px;
  background: #e8e8e8;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: #999999;
  margin: 24px auto 10px;
}
.main_left .titles {
  font-weight: 600;
  font-size: 28px;
  line-height: 40px;
  margin: 5px 0;
}
.page_info {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.info_img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  border-radius:50%;
}
.info_name {
  margin-right: 15px;
  font-size: 12px;
}
.info_data {
  margin-right: 20px;
  font-size: 12px;
  color: #999;
}
.info_comment {
  margin-right: 20px;
  font-size: 12px;
  color: #999;
}
.info_pv {
  font-size: 12px;
  color: #999;
}
.dz_box {
  margin: 40px auto;
  width: 100px;
  height: 60px;
  text-decoration: none;
  color: #333;
  border-radius: 40px;
  font-size: 14px;
  line-height: 24px;
  position: relative;
  background: #2397ee;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.dz_box img {
  width: 24px;
  height: 23px;
}
#qq {
  background-image: url("https://www.qudonghao.cn/static/assets/images/qq1.png");
  background-size: 100% 100%;
}
#qq:hover {
  background-image: url("https://www.qudonghao.cn/static/assets/images/qq2.png");
  background-size: 100% 100%;
  cursor: pointer;
}
#qqkj {
  background-image: url("https://www.qudonghao.cn/static/assets/images/kj1.png");
  background-size: 100% 100%;
}
#qqkj:hover {
  background-image: url("https://www.qudonghao.cn/static/assets/images/kj2.png");
  background-size: 100% 100%;
  cursor: pointer;
}
#wb {
  background-image: url("https://www.qudonghao.cn/static/assets/images/wb1.png");
  background-size: 100% 100%;
}
#wb:hover {
  background-image: url("https://www.qudonghao.cn/static/assets/images/wb2.png");
  background-size: 100% 100%;
  cursor: pointer;
}
.kzl_qfriend_share {
  width: 40px;
  height: 40px;
  margin-left: 15px;
}
.fx_friend {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.comment {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.textarea {
  padding: 10px;
  margin: 50px 0 20px;
  width: 760px;
  height: 122px;
  resize: none;
  outline: none;
  box-shadow: none;
  border: 1px solid #ccc;
}
.comment_sub {
  float: right;
  text-align: center;
  line-height: 36px;
  width: 94px;
  height: 36px;
  background: #2397ee;
  cursor: pointer;
  color: #fff;
}
.comment_list_title {
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}
.comment_list {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20px 0;
}

.comment_list_children {
  margin-top: 20px;
  width: 700px;
  margin-left: 65px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20px 5px;
  background: #f4f4f4;
}
.comment_list_left {
  display: flex;
}
.comment_list_left img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 20px;
}
.comment_list_children_left {
  display: flex;
}
.comment_list_children_left img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 20px;
}
.dianzan {
  width: 50px;
  display: inline-block;
  cursor: pointer;
  height: 16px;
  align-items: center;
  display: flex;
}
.dianzan img {
  margin-right: 10px;
}
.pinglun {
  width: 50px;
  align-items: center;
  display: inline-block;
  cursor: pointer;
  height: 16px;
  display: flex;
}
.pinglun img {
  margin-right: 10px;
}
.comment_list_right {
  display: flex;
}
.Hf_pl {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.hf_ipt {
  width: 710px;
  height: 32px;
}
.Hf_btn {
  width: 44px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background: #2397ee;
  border-radius: 4px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.comment_list_children_right {
  display: flex;
}
[v-cloak] {
  display: none;
}
.Contents {
  text-indent: 2rem;
  text-align:justify;
  line-height: 30px;
}
>>> .Contents p {
  margin: 15px 0;
}
>>> p img {
  margin: 0 auto;
  max-width:100%;
}
</style>